import React from 'react';
import { MapPin, Phone, Clock, Building } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0e3a63]" style={{borderTop: '1px solid transparent', background: 'linear-gradient(to right, rgba(239, 205, 134, 0.1), rgba(4, 106, 140, 0.1))'}}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img
                src="/assest/logo/logo.png"
                alt="MakSoft logo"
                className="h-16 w-auto object-contain brightness-110 contrast-110"
              />
            </div>
            <p className="text-white/90 mb-6 max-w-md">
              Your trusted partner in digital transformation, providing professional software solutions since 1996.
            </p>
            <div className="space-y-2 text-sm text-white/90">
              <div className="flex items-center gap-2">
                <Building size={16} />
                <span>Information Technology</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock size={16} />
                <span>Established: April 1996</span>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#EFCD86] mt-1 flex-shrink-0" />
                <div className="text-white/90 text-sm">
                  Office # 509, 5th Floor, Zulekha Trade Centre<br />
                  Bahadurabad, Karachi, Pakistan
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-[#EFCD86] flex-shrink-0" />
                <span className="text-white/90 text-sm">+92 300 2086828</span>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-white font-semibold mb-4">Business Hours</h3>
            <div className="space-y-2 text-sm text-white/90">
              <div className="flex justify-between">
                <span>FRIDAY:</span>
                <span>10AM–7:30PM</span>
              </div>
              <div className="flex justify-between">
                <span>SUNDAY:</span>
                <span>Closed</span>
              </div>
              <div className="flex justify-between">
                <span>MONDAY–SATURDAY:</span>
                <span>10AM–8PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#046A8C]/20 mt-8 pt-8 text-center">
          <p className="text-white/90 text-sm">
            © 2026 MakSoft. All rights reserved. | Founded in April 1996
          </p>
        </div>
      </div>
    </footer>
  );
}
